import { apiClient } from '@/lib/api-client';

export interface Membership {
  location_id: string;
  location_name: string;
  location_slug: string;
  role: string;
}

export interface CurrentOperator {
  id: string;
  email: string;
  name: string | null;
  email_verified_at: string | null;
  onboarding_completed_at: string | null;
  current_location_id: string | null;
  memberships: Membership[];
  is_platform_admin: boolean;
}

export interface SessionEnvelope {
  session_id: string;
  operator_id: string;
  email: string;
  name: string | null;
  current_location_id: string | null;
}

export interface SignupResponse extends SessionEnvelope {
  email_verification_required: boolean;
  dev_verification_code?: string | null;
}

export interface MemberRow {
  id: string;
  email: string;
  name: string | null;
  role: string;
  last_login_at: string | null;
  created_at: string;
}

export interface InviteResult {
  invite_id: string;
  email: string;
  invite_url: string;
  expires_at: string;
}

export const authApi = {
  me: () => apiClient.get<CurrentOperator>('/api/v1/auth/me'),
  login: (input: { email: string; password: string }) =>
    apiClient.post<SessionEnvelope>('/api/v1/auth/login', input),
  signup: (input: {
    organization_name: string;
    email: string;
    password: string;
    name?: string;
  }) => apiClient.post<SignupResponse>('/api/v1/auth/signup', input),
  logout: () => apiClient.post<void>('/api/v1/auth/logout'),
  forgotPassword: (email: string) =>
    apiClient.post<void>('/api/v1/auth/forgot-password', { email }),
  resetPassword: (input: { token: string; password: string }) =>
    apiClient.post<void>('/api/v1/auth/reset-password', input),
  acceptInvite: (input: { token: string; password: string; name?: string }) =>
    apiClient.post<SessionEnvelope>('/api/v1/auth/accept-invite', input),
  verifyEmail: (code: string) =>
    apiClient.post<void>('/api/v1/auth/verify-email', { code }),
  invite: (input: { email: string; role?: string }) =>
    apiClient.post<InviteResult>('/api/v1/auth/invite', input),
  members: () =>
    apiClient
      .get<{ items: MemberRow[] }>('/api/v1/auth/members')
      .then((r) => r.items),
};
